import { CellTableWithCopyableTooltip } from "@/molecules/CellTableWithCopyableTooltip"

import type { DigestImageCellComponent } from "."

export const DigestImageCell: DigestImageCellComponent = (value, record) => (
  <CellTableWithCopyableTooltip value={value} copyableText={record.digest} />
)
